import { render, staticRenderFns } from "./NetIncome.vue?vue&type=template&id=2fc1d92e"
import script from "./NetIncome.vue?vue&type=script&lang=js"
export * from "./NetIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports